import easyfyHttpClient from '@shared/easyfy.httpclient';

namespace Easyfy.Web.Services.Basket {
  export interface IBasket {
    rows: IBasketRow[];
  }

  export interface ITrackingData {
    listName?: string;
    listId?: string;
    searchProductOrigin?: string;
    additionalData?: Record<string, string>;
  }

  export interface IBasketRow {
    productId?: string;
    searchProductId?: string;
    salesUnitCode?: string;
    rowId?: string;
    setQty?: number;
    changeQty?: number;
    trackingData?: ITrackingData;
    rowAttributes?: { [key: string]: string };
    properties?: { [key: string]: string };
    purchaseType?: IPurchaseType;
    subscriptionOptions?: ISubscriptionOptions;
  }

  export interface BasketValidation {
    basketId: string;
    rowValidations: BasketRowValidation[];
    isValid: boolean;
  }

  export interface BasketRowValidation {
    basketRowId: string;
    errorCodes: string[];
    isValid: boolean;
  }

  export interface ISubscriptionOptions {
    optionId?: string;
    qty?: number;
  }
  export enum IPurchaseType {
    OneTimePurchase,
    Subscription,
  }

  export enum UpsellKey {
    UpsellId = 'Upsell.Id',
    UpsellCode = 'Upsell.Code',
    UpsellName = 'Upsell.Name',
    UpsellZone = 'Upsell.Zone',
  }

  export const UpdateBasket = async (data: IBasket, token: string): Promise<any> => {
    return await easyfyHttpClient.post('/api/basket?handler=save', data, token);
  };

  export const GetBasket = async (): Promise<any> => {
    return await easyfyHttpClient.get('/api/basket');
  };

  export const ClearBasket = async (token: string): Promise<any> => {
    return await easyfyHttpClient.post('/api/basket?handler=clear', {}, token);
  };
}

export default Easyfy.Web.Services.Basket;
